/*
 * @Author: Ashley.Liu
 * @Date: 2022-04-26 13:26:14
 * @LastEditTime: 2022-05-13 16:11:35
 * @Description: desc
 */
import request, { genRequestInstance } from './helpers'
const service = genRequestInstance()
/**
 *
 * @param {*} data
 * {
  "unsafeConfigMap": {
    "additionalProp1": "string",
    "additionalProp2": "string",
    "additionalProp3": "string"
  }
}
 * @returns
 */
export function insertUnsafeConfig (data) {
    return request({
        url: '/api/v1/unsafe/config/insert',
        method: 'post',
        data
    })
}
export function deleteUnsafeConfig (names) {
    return request({
        url: '/api/v1/unsafe/config/delete',
        method: 'delete',
        data: names
    })
}
export function listUnsafeConfig (data) {
    return request({
        url: 'api/v1/unsafe/config/list',
        method: 'get',
        data
    })
}
export function getUsafeConfig (name) {
    return service({
        url: '/api/v1/unsafe/config',
        method: 'get',
        params: {
            name
        }
    })
}
